<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    :nudge-right="40"
    transition="scale-transition"
    offset-y
    min-width="auto"
    :disabled="disabled"
  >
    <template #activator="{ on, attrs }">
      <span :class="labelClass">
        <span class="mt-3"> {{ label }}</span>
        <v-text-field
          v-model="date"
          readonly
          v-bind="attrs"
          required
          :error-messages="errors"
          class="search-input ml-3"
          solo
          dense
          :disabled="disabled"
          v-on="on"
        >
          <template #append>
            <v-icon color="black">mdi-calendar-blank</v-icon>
          </template>
        </v-text-field></span
      >
    </template>
    <v-date-picker
      v-model="date"
      :max-date="maxDate"
      :min-date="minDate"
      locale="es"
      @input="menu = false"
    />
  </v-menu>
</template>

<script>
  /* eslint-disable vue/require-default-prop, vue/require-prop-types */
  import moment from 'moment';

  export default {
    name: 'InputDatePicker',

    props: {
      value: {
        type: String,
        required: false,
      },

      label: {
        type: String,
        required: false,
      },

      dateFormat: {
        type: String,
        default: 'YYYY-MM-DD',
      },

      minDate: {
        type: Date,
        default: null,
      },

      maxDate: {
        type: Date,
        default: null,
      },

      errors: {
        type: [Array, String],
        default: () => [],
      },
      labelClass: {
        type: String,
        default: 'in-line',
      },
      disabled: Boolean,
    },

    data() {
      return {
        menu: false,
        switchOn: false,
      };
    },

    computed: {
      date: {
        set(newValue) {
          if (newValue !== null) {
            const date = moment(newValue).format(this.dateFormat);
            this.$emit('input', date);
          } else this.$emit('input', null);
        },

        get() {
          if (this.value !== null) {
            const date = moment(this.value, this.dateFormat, true).format(
              'YYYY-MM-DD'
            );
            return date;
          }

          return null;
        },
      },
    },

    methods: {
      emitDateSelection(date) {
        this.menu = false;
        this.$emit('onSelect', date);
      },
    },
  };
</script>
<style scoped>
  .search-input {
    border-radius: 5px;
    padding-right: 0px;
  }

  .in-line {
    display: flex;
    color: black;
    font-weight: bold;
  }
</style>
